import { render, staticRenderFns } from "./list-video-x.vue?vue&type=template&id=3ccbb08f&scoped=true"
import script from "./list-video-x.vue?vue&type=script&lang=js"
export * from "./list-video-x.vue?vue&type=script&lang=js"
import style0 from "./list-video-x.vue?vue&type=style&index=0&id=3ccbb08f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccbb08f",
  null
  
)

export default component.exports